import type { FonotekaTrack, FonotekaTrackLite } from '@/api/client';

/** Трек каталога в том виде, что отдают окно выбора и блок карточки (сервер — TRACK_LITE_SQL в fonoteka/lazyCatalog.ts) */
export function fonotekaTrackLite(t: FonotekaTrack): FonotekaTrackLite {
  return {
    id: t.id,
    pack_id: t.pack_id,
    file_name: t.file_name,
    file_url: t.file_url,
    uploaded_at: t.uploaded_at,
    uploaded_by_name: t.uploaded_by_name,
    duration_sec: t.duration_sec,
  };
}
